<template>
  <textarea
    :aria-label="` ${field.datahash.label}; ${statement.label}; Comment;`"
    class="tw-textarea"
    @change="handleChange"
    v-model="answer.data.value"
    ng-model-options="{ updateOn: 'default blur-sm', debounce: { 'default': 250, 'blur-sm': 0 } }"
    name="comments"
  >
</textarea>
</template>
<script>
import editMixin from './_mixin_edit.js'
export default {
  mixins: [editMixin],
  props: {
    field: {},
    statement: {},
  },
  emits: ['update'],
  skipBasic: true,
  created () {
    const answer = this.answerInit(
      this.field,
      {
        data: {
          value: '',
          field_statement_label: this.statement.label,
          comment: true,
        },
        option_id: this.statement.option_id,
        likert_id: null, // "marks this as a comment" -- Unknown
      },
      {
        no_mapping: true,
      }
    )

    this.answer = this.formResultStore.findAnswer(answer) || answer

    this.formResultStore.addAnswer(this.answer)
  },
  methods: {
    handleChange(){
      this.answerSetter(this.answer)
      this.$emit('update', this.answer)
    },
    answerSetter(answer){
      this.commentAnswerSetter(answer)
    },
    commentAnswerSetter(answer){
      this.setLikertComment(answer)
    },
    answerInit(...args){
      return this.commentAnswerInit(...args)
    },
    commentAnswerInit(...args){
      return this.initializeAnswer(...args)
    },

    setLikertComment(answer) {
      return
    },
  }
}
</script>